export default __webpack_public_path__ + "static/media/Degen_token.badd30df.png";